import { AbortedError } from 'src/common/api/extended-emerald-error';
import { restorePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import { ItemAddType } from 'src/common/enumerations/item-add-type';
import { UnitOfMeasureTypes } from 'src/common/enumerations/unit-of-measure-type';
import { IItemLookup, ILinkedItemsGroup } from 'src/common/interfaces/dtos/IItemLookup';
import { IManualTare } from 'src/common/interfaces/dtos/IManualTare';
import { LineItemAddDto } from 'src/items-list/business-logic/service/interfaces/line-item-add.dto';
import { getLinkedItemsDetails } from 'src/linked-item/handle-linked-item';
import { NoneItemId } from 'src/linked-item/sell-linked-item';
import { addTareWeightGroup } from 'src/linked-item/tare-weight-groups-operation';
// import { popupMessage } from 'src/messages/business-logic/popup-message';
import { getTareWeightItemsData } from 'src/tare-weight-items/business-logic/handle-tare-weight-items';
import {
  ITareWeigthItemsProps,
  showTareWeightItemsScreen,
} from 'src/tare-weight-items/tare-weight-items';

export const handlePriceOverrideTareWeightItems = async (
  lineItem: LineItemAddDto,
  itemLookup: IItemLookup,
): Promise<void> => {
  const emptyILinkedItems: ILinkedItemsGroup = {
    linkedItems: [],
  };
  const linkedItemDetails = await getLinkedItemsDetails(
    itemLookup?.linkedItemsGroup ?? emptyILinkedItems,
  );
  const linkedItems = linkedItemDetails.itemLookupData;

  addTareWeightGroup(lineItem.item.id, linkedItems, itemLookup?.isManualTarePercentageEnabled);

  await showPriceOverrideTareWeightItems(lineItem, itemLookup, linkedItems);
};

const showPriceOverrideTareWeightItems = async (
  lineItem: LineItemAddDto,
  itemLookup: IItemLookup,
  tareWeightItems?: IItemLookup[],
): Promise<void> => {
  const {
    isTareModification,
    isManualTarePercentageEnabled,
    canManualTareWeight,
    grossWeight,
    tarePercentage,
    showPreDefinedOptionsForTareWeightItem,
  } = await getTareWeightItemsData(lineItem, itemLookup, tareWeightItems);

  return new Promise<void>((resolve, reject) => {
    const onClose = (): void => {
      reject(new AbortedError());
    };

    const onSubmit = async (value: number, isPercentage: boolean): Promise<void> => {
      const manualTare: IManualTare = { value, isPercentage };
      lineItem.itemAddType = ItemAddType.Tare;
      bindTareWeight(lineItem, manualTare);
      resolve();
    };

    const onSelect = async (tareItem: IItemLookup): Promise<void> => {
      lineItem.itemAddType = ItemAddType.Tare;
      bindLinkedItem(lineItem, tareItem);
      resolve();
    };

    const onSelectPercentage = (tareValue: number): void => {
      onSubmit(tareValue, true);
    };

    if ((tareWeightItems?.length || 0) + (tarePercentage?.length || 0) === 1) {
      if (tareWeightItems?.length) {
        onSelect(tareWeightItems[0]);
      } else if (tarePercentage?.length) {
        onSelectPercentage(tarePercentage[0]);
      }
    } else {
      const tareWeightItemsProps: ITareWeigthItemsProps = {
        linkedGroupItems: tareWeightItems,
        isTareModification: isTareModification,
        onClose,
        onSubmit,
        onSelect,
        onSelectPercentage,
        isManualTarePercentageEnabled,
        canManualTareWeight,
        grossWeight,
        tarePercentage: tarePercentage,
        showPreDefinedOptionsForTareWeightItem,
      };

      showTareWeightItemsScreen(tareWeightItemsProps);
    }
  }).finally(() => restorePage());
};

const bindLinkedItem = (lineItem: LineItemAddDto, tareItem: IItemLookup): void => {
  if (tareItem.itemId !== NoneItemId) {
    lineItem.linkedItems = [
      ...(lineItem?.linkedItems || []),
      {
        item: {
          id: tareItem.itemId || '',
          entryMethod: EntryMethod.Tapped,
        },
        quantity: {
          value: 1,
          entryMethod: EntryMethod.Automatic,
        },
        uomCode: tareItem.unitsOfMeasure || UnitOfMeasureTypes.Each,
        withData: false,
      },
    ];
  }
};

const bindTareWeight = (lineItem: LineItemAddDto, manualTare: IManualTare): void => {
  lineItem.tareWeight = {
    tareValue: manualTare.value,
    grossWeight: lineItem.quantity.value,
    isManualPercentage: manualTare.isPercentage,
    isTareOverride: true,
  };
};
